import { colors } from '@constants/colors';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();

  return {
    root: (isActive = false) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
      backgroundColor: isActive ? '#0C0B0BB2' : '#0C0B0B66',
      border: `1px solid ${isActive ? appTheme.mainColor : '#666666'}`,
      borderRadius: 2,
      padding: 1,
      width: 128,
      minWidth: 128,
      maxWidth: 128,
      flex: 1,
      height: 152,
      boxSizing: 'border-box',
      cursor: 'pointer',
      textAlign: 'center',
      '&:hover': {
        borderColor: appTheme.mainColor,
        backgroundColor: '#0C0B0BB2',
      },

      '& img': {
        height: 85,
        objectFit: 'cover',
        minWidth: '100%',
        borderRadius: 1,
      },
    }),
    placeholder: {
      minWidth: '100%',
      height: 85,
      borderRadius: 1,
      backgroundColor: colors.white,
    },

    title: {
      fontSize: 14,
      color: colors.white,
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
};
